import { useState } from "react";
import { HolidayEvent } from "../../../../pages/calendar";
import SvgIcon from "../icons";
import "./style.css";
import UserModal from "../UserModal";
import localforage from "localforage";
import LimitModal from "../LimitModal";
import { useFreetrialDayPost } from "../../../../queries/freetrial";

interface DayProps {
  date: Date;
  events: HolidayEvent[];
  handleLocation: any;
  locationValid: Boolean;
}
export const Day: React.FC<DayProps> = ({
  date,
  events,
  handleLocation,
  locationValid,
}) => {
  const [loadingEventTitles, setLoadingEventTitles] = useState<{ [key: string]: boolean }>({});
  const [eventContent, setEventContent] = useState<{
    [key: string]: string | null;
  }>({});
  const [tooltipStates, setTooltipStates] = useState<any>({});
  const [showTooltip, setShowTooltip] = useState<number | null>(null);
  const { mutateAsync: freetrialDayPost } = useFreetrialDayPost();
  const dayOfWeek = date.toLocaleString("en-US", { weekday: "short" });
  const dayOfMonth = date.getDate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLimitModalOpen, setIsLimitModalOpen] = useState(false);
  const currentDate = new Date().getDate();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeLimit_withRedirect = () => {
    setIsLimitModalOpen(false);
    window.open('https://go.maybetech.com/calendar-upgrade-social', '_self');
  };

  const closeLimitModel = () => {
    setIsLimitModalOpen(false);
    window.open('https://go.maybetech.com/masterclass', '_self');
  };

  const handleRequest = async (title: string, date: string) => {
    if (loadingEventTitles[title]) {
      return;
    }

    setLoadingEventTitles((prevLoadingEventTitles) => ({
      ...prevLoadingEventTitles,
      [title]: true,
    }));

    try {
      const result = await freetrialDayPost({ title, date });

      if (result.limitReached) {
        setIsLimitModalOpen(true);
        setLoadingEventTitles((prevLoadingEventTitles) => ({
          ...prevLoadingEventTitles,
          [title]: false,
        }));
        return false;
      }

      setEventContent((prevContent) => ({
        ...prevContent,
        [title]: result.content,
      }));
      setLoadingEventTitles((prevLoadingEventTitles) => ({
        ...prevLoadingEventTitles,
        [title]: false,
      }));
    } catch (error) {
      // Preserved from the old useHttp-based calls: a failed request left
      // loadingEventTitles stuck true rather than surfacing an error UI.
    }
  };

  const copyEventContent = (content: string | null, eventIndex: number) => {
    if (content == null) return false;
    const tempEl = document.createElement("div");
    tempEl.innerHTML = content;

    // Append the temporary element to the body
    document.body.appendChild(tempEl);

    // Create a range and select the content of the temporary element
    const range = document.createRange();
    range.selectNodeContents(tempEl);

    // Remove any current selections and add the new range
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);

    // Copy the selected content to the clipboard
    try {
      document.execCommand("copy");
      setTooltipStates((prevStates: any) => ({
        ...prevStates,
        [eventIndex]: "Copied!",
      }));
    } catch (err) {
      console.error("Failed to copy! ", err);
    }

    // Clear the selection and remove the temporary element
    selection?.removeAllRanges();
    tempEl.remove();

    setTimeout(() => {
      setTooltipStates((prevStates: any) => ({
        ...prevStates,
        [eventIndex]: "Copy!",
      }));
    }, 1500);
  };

  const handleBoxClick = (title: string, date: string) => {
    if (eventContent[title] === undefined) {
      handleRequest(title, date);
    }
  };

  return (
    <div className="mt-8 flex flex-wrap">
      <div
        className="dayDate flex flex-col items-start mb-4 w-[5%]"
        id={currentDate.toString() == dayOfMonth.toString() ? "focus" : ""}
      >
        <h2>{dayOfMonth}</h2>
        <p>{dayOfWeek.toUpperCase()}</p>
      </div>
      <LimitModal
        isModalOpen={isLimitModalOpen}
        closeModalWithRedirect={closeLimit_withRedirect}
        justCloseIt={closeLimitModel}
      />
      <UserModal
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        handleLocation={handleLocation}
      />
      <div className="dayEvents w-[95%]">
        {events.length > 0 ? (
          <div className="flex flex-wrap w-full">
            {events.map((event, index) => (
              <div key={index} className="w-full md:w-1/3 mb-4 p-5 pt-0 pl-0">
                <div className="eventBoxWrapper p-5" onClick={() => handleBoxClick(event.title, event.date)}>
                  {loadingEventTitles[event.title] && (
                    <div className="loadingReq text-center">
                      <h4>
                        <span className="flip-emoji">✍️</span>
                        <span className="flip-emoji">😃</span>
                      </h4>
                      <p className="typing-text">
                        Writing post
                        <span className="dot">.</span>
                        <span className="dot">.</span>
                        <span className="dot">.</span>
                      </p>
                    </div>
                  )}
                  <div className="eventBox px-5 flex flex-col justify-between h-full">
                    <div className="dayMetaInfo">
                      <h2 className="eventTitle mb-3">{event.title}</h2>
                      <p className="eventContent">
                        {loadingEventTitles[event.title] ? (
                          "Loading..."
                        ) : (
                          <div
                            className="eventContent"
                            dangerouslySetInnerHTML={{
                              __html: eventContent[event.title] || "",
                            }}
                          />
                        )}
                      </p>
                      {eventContent[event.title] === undefined && (
                        <p className="eventHashtag">{event.hashtags}</p>
                      )}
                    </div>
                    <div className="dayActions pb-2">
                      {eventContent[event.title] === undefined ? (
                        <button
                          className="writePost"
                        >
                          <SvgIcon id={"stars"} />
                          Write me a Post
                        </button>
                      ) : (
                        <div className="flex align-items-center justify-between">
                          {/* isModalOpen, closeModal */}
                          {locationValid ? (
                            <></>
                          ) : (
                            <button className="personalise" onClick={openModal}>
                              <SvgIcon id={"stars"} />
                              Personalise
                            </button>
                          )}
                          {/* <button className="writePost">Schedule</button> */}
                          <button
                            className="copyContent"
                            onMouseEnter={() => setShowTooltip(index)}
                            onMouseLeave={() => setShowTooltip(null)}
                            onClick={() =>
                              copyEventContent(eventContent[event.title], index)
                            }
                          >
                            <SvgIcon id={"copy"} />
                            {showTooltip === index && (
                              <div className="toolTipBox">
                                {tooltipStates[index] || "Copy!"}
                              </div>
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};